import { createContext } from 'react';
import type { CustomFeature } from '@types';
import type { CFSetData } from './typeHelpers';

const CustomFeatureContext = createContext<{
  data?: CustomFeature;
  setData: CFSetData<CustomFeature>;
}>({
  setData: () => {},
});

export default CustomFeatureContext;
